const CameraIcon = ({ width = 24, height = 24 }: { width?: number; height?: number }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.76125 6.75H4.5C3.903 6.75 3.33075 6.987 2.90925 7.40925C2.487 7.83075 2.25 8.403 2.25 9V18C2.25 18.597 2.487 19.1693 2.90925 19.5908C3.33075 20.013 3.903 20.25 4.5 20.25H19.5C20.097 20.25 20.6693 20.013 21.0907 19.5908C21.513 19.1693 21.75 18.597 21.75 18V9C21.75 8.403 21.513 7.83075 21.0907 7.40925C20.6693 6.987 20.097 6.75 19.5 6.75H17.2388L16.7948 5.32875C16.5015 4.38975 15.6315 3.75 14.6475 3.75C13.227 3.75 10.773 3.75 9.3525 3.75C8.3685 3.75 7.4985 4.38975 7.20525 5.32875L6.76125 6.75ZM7.3125 8.25C7.64025 8.25 7.9305 8.037 8.028 7.7235L8.637 5.7765C8.7345 5.463 9.02475 5.25 9.3525 5.25H14.6475C14.9753 5.25 15.2655 5.463 15.363 5.7765L15.972 7.7235C16.0695 8.037 16.3597 8.25 16.6875 8.25H19.5C19.6987 8.25 19.89 8.32875 20.0303 8.46975C20.1713 8.61 20.25 8.80125 20.25 9V18C20.25 18.1987 20.1713 18.39 20.0303 18.5303C19.89 18.6713 19.6987 18.75 19.5 18.75H4.5C4.30125 18.75 4.11 18.6713 3.96975 18.5303C3.82875 18.39 3.75 18.1987 3.75 18V9C3.75 8.80125 3.82875 8.61 3.96975 8.46975C4.11 8.32875 4.30125 8.25 4.5 8.25H7.3125ZM12 8.25C9.51675 8.25 7.5 10.2667 7.5 12.75C7.5 15.2332 9.51675 17.25 12 17.25C14.4832 17.25 16.5 15.2332 16.5 12.75C16.5 10.2667 14.4832 8.25 12 8.25ZM12 9.75C13.656 9.75 15 11.094 15 12.75C15 14.406 13.656 15.75 12 15.75C10.344 15.75 9 14.406 9 12.75C9 11.094 10.344 9.75 12 9.75Z"
        fill="black"
      />
    </svg>
  );
};

export { CameraIcon };
